enum ApiNotifDataOperation {
    Insert = 'i',
    Update = 'u',
    Delete = 'd'
};

export default ApiNotifDataOperation;